export default __webpack_public_path__ + "static/media/Destination1.b43b40eb.png";